import 'twin.macro';

import { useQuery } from '@apollo/client';
import { navigate } from '@reach/router';
import { HAS } from 'api/queries';
import IconMultimedia from 'assets/svg/icons/multimedia.inline.svg';
import PopupPassword from 'components/Molecules/popups/PopupPassword';
import SubHeader from 'components/Organisms/SubHeader';
import LoadingState from 'components/Templates/shareholding/LoadingState';
import { routes } from 'constants/routes';
import HeaderContext from 'providers/HeaderProvider';
import React, { useContext, useEffect,  useState } from 'react';
import loadable from '@react-loadable/revised'

const RouterComponent = loadable({
	loader: () => import('components/Templates/shareholding/RouterComponent'),
	loading: LoadingState
});

export default function shareholding() {
	const { setHeader } = useContext(HeaderContext);

	const [message, setMessage] = useState(null);
	const [isPasswordDialog, setPasswordDialog] = useState(true);
	const [password, setPassword] = useState(null);

	const { loading, error: errorFetch } = useQuery(HAS.NEWS_PASSWORD, {
		fetchPolicy: 'cache-and-network',
		onCompleted: ({ hasNewsPassword }) => {
			setPasswordDialog(hasNewsPassword);
			handleSessionStorage();
		}
	});

	if (errorFetch) navigate(routes.SERVER_ERROR);

	useEffect(() => {
		setHeader({ isMain: true });
	}, []);

	const handleSendPassword = password => {
		setPasswordDialog(false);
		setPassword(password);
		setMessage(null);
	};

	const handleWrongPassword = message => {
		setPasswordDialog(true);
		setMessage(message);
	};

	const handleSessionStorage = () => {
		if(typeof window !== 'undefined') {
			const password = window.sessionStorage.getItem('shareholding_pass');
			if(password) {
				setPasswordDialog(false);
				setPassword(password);
			}
		}
	};

	return (
		<div>
			<SubHeader tw='fixed top-0 mt-nav z-nav' Icon={IconMultimedia} title='Relacje z akcjonariuszami' iconSize='1.7rem' />

			{loading ? <LoadingState /> : (
				isPasswordDialog ? (
					<PopupPassword isOpen={isPasswordDialog} message={message} onSubmit={handleSendPassword} onClose={() => {}} />
				) : (
					<RouterComponent password={password} onError={handleWrongPassword} />
				)
			)}
		</div>
	);
}
